import React, { useState } from "react";
import ModalForm from "../../components/ModalForm";
import CustomTextInput from "../../components/CustomTextInput";
import api from "../../api";

export default function DriverModal({ isOpen, onClose, onDriverAdded }) {
  const [name, setName] = useState("");
  const [govId, setGovId] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isAdded, setIsAdded] = useState(false);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setFieldErrors({});
    setError(null);

    const formData = {
      name: name,
      govId: govId,
      email: email,
      phone: contact,
    };

    try {
      await api.drivers.create(formData);
      setIsAdded(true); // Marca como agregado
      onDriverAdded(true); // Notifica al componente principal
      onClose(); // Cierra el modal
      setName("");
      setGovId("");
      setEmail("");
      setContact("");
    } catch (error) {
      if (error.message) {
        setFieldErrors(error.message); // Ajustar esto según la estructura del error
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    }
  };

  return (
    <ModalForm
      title="Agrega un nuevo conductor"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleFormSubmit}
      textBtn="Agregar conductor"
    >
      {/* Muestra un error general si existe */}
      {error && <p className="text-red-600 mb-4">{error}</p>}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Nombre del conductor"
            placeholder="Ingresa el nombre del conductor"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isRequired
          />
          {/* Muestra error específico para el campo "name" */}
          {fieldErrors.name && (
            <p className="text-red-600 text-sm">{fieldErrors.name[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Cédula de identidad"
            placeholder="Ingresa tu número de documento"
            type="text"
            value={govId}
            onChange={(e) => setGovId(e.target.value)}
            isRequired
          />
          {/* Muestra error específico para el campo "govId" */}
          {fieldErrors.govId && (
            <p className="text-red-600 text-sm">{fieldErrors.govId[0]}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Correo electrónico"
            placeholder="Ingresa el correo electrónico"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {/* Muestra error específico para el campo "email" */}
          {fieldErrors.email && (
            <p className="text-red-600 text-sm">{fieldErrors.email[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Número de celular"
            placeholder="Escribe el número de celular"
            type="text"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            isRequired
          />
          {/* Muestra error específico para el campo "phone" */}
          {fieldErrors.phone && (
            <p className="text-red-600 text-sm">{fieldErrors.phone[0]}</p>
          )}
        </div>
      </div>
    </ModalForm>
  );
}
